import { render, staticRenderFns } from "./editDriverDan.vue?vue&type=template&id=b5afc7d6&scoped=true&"
import script from "./editDriverDan.vue?vue&type=script&lang=js&"
export * from "./editDriverDan.vue?vue&type=script&lang=js&"
import style0 from "./editDriverDan.vue?vue&type=style&index=0&id=b5afc7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5afc7d6",
  null
  
)

export default component.exports